import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'
import type { AppDispatch, RootState } from './store'

/** Typed `dispatch` hook for the Redux store. */
export const useAppDispatch = () => useDispatch<AppDispatch>()
/** Typed `selector` hook for the Redux store. */
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
